import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 4q3.65 0 6.65 2.037T23 11.5q-1.35 3.425-4.35 5.463Q15.65 19 12 19t-6.65-2.037T1 11.5q1.35-3.425 4.35-5.463Q8.35 4 12 4m0 3q-1.875 0-3.187 1.313Q7.499 9.625 7.5 11.5q0 1.875 1.313 3.188Q10.125 16 12 16t3.188-1.312T16.5 11.5t-1.312-3.187T12 7m0 1.8q1.125 0 1.912.788.788.787.788 1.912t-.788 1.912A2.6 2.6 0 0 1 12 14.2q-1.125 0-1.912-.788A2.6 2.6 0 0 1 9.3 11.5q0-1.125.788-1.912A2.6 2.6 0 0 1 12 8.8" })
});
export default SvgEyeOn;
